import {UnderwriterState, UnderwriterStore} from './underwriter.store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from '../../shared/state/signal-entity.store';
import {UnderwriterMain} from '../../shared/models/underwriter.model';

@Injectable({ providedIn: 'root' })
export class UnderwriterQuery extends SignalEntityQuery<any, UnderwriterState> {
  constructor(protected store: UnderwriterStore) {
    super(store);
  }

  getPolicyHolderDetails(): Observable<UnderwriterMain[]> {
   return this.selectAll({
     filterBy: [
       entity => entity.index === 1
     ]
   });
  }

  getPolicyDetails(): Observable<UnderwriterMain[]> {
    return this.selectAll({
      filterBy: [
        entity => entity.index === 2
      ]
    });
   }

  getClasses(): Observable<UnderwriterMain[]> {
    return this.selectAll({
      filterBy: [
        entity => entity.index === 3
      ]
    });
   }

  getQuestion(): Observable<UnderwriterMain[]> {
    return this.selectAll({
      filterBy: [
        entity => entity.index === 4
      ]
    });
  }

}
